import { Route } from "react-router-dom";
import { APP_URLS } from "../../../utils/constant";
import VehicleMakeScreen from "../../../container/Vehicles/VehicleMakeScreen";
import CreateVehicleMake from "../../../container/Vehicles/VehicleMakeScreen/CreateVehicleMake";

const VehicleMakeRoutes = (access = {}) => {
  const { create, view, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.VEHICLE_MAKE.HOME}
          element={<VehicleMakeScreen screenPermissions={access} />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.VEHICLE_MAKE.CREATE}
          element={<CreateVehicleMake />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.VEHICLE_MAKE.EDIT}
          element={<CreateVehicleMake isEdit={true} />}
        />
      )}
    </>
  );
};

export default VehicleMakeRoutes;
